import { ServiceTimePerStop } from "../../../models";

// Maps the model back to the bare settings `value` object the PUT body expects
// (`dumpYard` -> `dump_yard`; no `{ unit, value }` envelope on the request).
export const toServiceTime = (
  model: ServiceTimePerStop
): { delivery: number; pickup: number; dump_yard: number; storage: number } => ({
  delivery: model.delivery,
  pickup: model.pickup,
  dump_yard: model.dumpYard,
  storage: model.storage,
});
